const firebaseConfig = {
  apiKey: "AIzaSyBeIOYFvOh2vXiXLr1xyTLWNV4a20LqF70",
  authDomain: "authentication-is-running.firebaseapp.com",
  projectId: "authentication-is-running",
  storageBucket: "authentication-is-running.appspot.com",
  messagingSenderId: "298009180232",
  appId: "1:298009180232:web:981bba4d9d34150f79407d"
};

export default firebaseConfig
